var mentions_default = {
  "mention": "noJKv",
  "mentionViewer": "aRX4O",
  "cursorDefault": "MziBz",
  "cursorPointer": "mfAe5"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
